import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { UploadService } from '../../../services/upload/upload.service';

@Component({
  selector: 'sb-comp-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false,
})
export class FileUploadComponent {
  @HostBinding('className') componentClass: string;
  @ViewChild('filePicker') filePicker: ElementRef;
  @Input() uploadType: string;
  @Input() parent: any;
  @Output() fileDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isDragOverEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public uploadService: UploadService) {
    this.componentClass = 'h-100 w-100';
  }

  openFilePicker() {
    this.filePicker.nativeElement.click();
  }

  dragOverHandler(event) {
    event.preventDefault();
  }

  dropHandler(event) {
    event.preventDefault();
    this.uploadService.dropHandler(event, this.uploadType, this.parent);
  }

  filePicked() {
    this.uploadService.handleFileUpload(this.filePicker.nativeElement.files, this.uploadType, this.parent);
    this.filePicker.nativeElement.value = '';
  }
}
